import tinycolor from 'tinycolor2';

import type { InteractionInfo } from '$/components/Interactions/InteractionInfo';

import { PublicEWebinarFragment } from '$/GraphQL/schema/types';
import { readableColorOnBackground } from '$/utils/colors';

export function useInteractionIconColor(
  interaction: InteractionInfo,
  ewebinar: PublicEWebinarFragment,
  options?: { forDock?: boolean; inverted?: boolean }
): { css: string; color: string; secondaryColor: string; showBadge: boolean } {
  const primary = tinycolor(ewebinar.primaryColor).toHexString();
  let color = interaction.color() ?? primary;
  let secondaryColor = primary;

  if (options?.inverted) {
    secondaryColor = color = readableColorOnBackground(ewebinar.actionColor);
  }

  return {
    css: `
      color: ${color};
      --fa-secondary-color: ${secondaryColor};
    `,
    color,
    secondaryColor,
    showBadge:
      interaction.points() > 0 && !interaction.isAnswered() && !interaction.isResultsCard(),
  };
}
